<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="16"
      cy="13"
      r="3.5"
      fill="#1DB6BD"
      stroke="#18181B"
      stroke-miterlimit="4.13357"
      stroke-linecap="round"
    />
    <path
      d="M14.25 18.5H17.75C20.3734 18.5 22.5 20.6266 22.5 23.25C22.5 23.9404 21.9404 24.5 21.25 24.5H10.75C10.0596 24.5 9.5 23.9404 9.5 23.25C9.5 20.6266 11.6266 18.5 14.25 18.5Z"
      fill="#1DB6BD"
      stroke="#18181B"
    />
    <circle
      cx="6.25"
      cy="9"
      r="2.5"
      stroke="#18181B"
      stroke-miterlimit="4.13357"
      stroke-linecap="round"
    />
    <path
      d="M4.33301 13.5H7.66699C9.23154 13.5002 10.4998 14.7685 10.5 16.333C10.5 16.9773 9.97734 17.5 9.33301 17.5H2.66699C2.02266 17.5 1.5 16.9773 1.5 16.333C1.50018 14.7685 2.76846 13.5002 4.33301 13.5Z"
      stroke="#18181B"
    />
    <circle
      cx="26.25"
      cy="9"
      r="2.5"
      stroke="#18181B"
      stroke-miterlimit="4.13357"
      stroke-linecap="round"
    />
    <path
      d="M24.333 13.5H27.667C29.2315 13.5002 30.4998 14.7685 30.5 16.333C30.5 16.9773 29.9773 17.5 29.333 17.5H22.667C22.0227 17.5 21.5 16.9773 21.5 16.333C21.5002 14.7685 22.7685 13.5002 24.333 13.5Z"
      stroke="#18181B"
    />
  </svg>
</template>

<script>
export default {
  name: 'Clubs',
}
</script>

<style lang="scss" scoped></style>
